import { SelectTramiteComponent } from '@app/shared/select-tramite/select-tramite.component';
import { TimeContolDataService } from './../shared/time-contol.data.service';
import { StagesTimeControlDataService } from './../stages-time-control/shared/stages-time-control.data.service';
import { History } from '@app/flow/flow.component';
import { TramitStagesFormService } from './shared/tramit-stages.form.service';
import { ToastrService } from 'ngx-toastr';
import { LocalDataSource } from 'ng2-smart-table';
import { Component, OnInit, TemplateRef, ViewChild, EventEmitter, Output, Input } from '@angular/core';
import {
  BaseControl,
  ConfirmComponent,
  Categoria,
  Proceso,
  TramiteDefaultCorto,
  EtapaBase,
  EtapaDetalleApi,
  Const
} from '@app/shared';
import { Logger, AuthenticationService } from '@app/core';
import { TramitStagesDataService } from './shared/tramit-stages.data.service';
import { TramitStagesConfigService } from './shared/tramit-stages.config.service';

export interface InfoStages {
  id: number;
  etapa: string;
  etapa_id: number;
  tiempo: number;
  porcentaje_alerta: number;
  dias_habiles: boolean;
  update: boolean;
  delete: boolean;
  review: boolean;
}

const log = new Logger('TramitStagesComponent');
@Component({
  selector: 'iw-tramit-stages',
  templateUrl: './tramit-stages.component.html',
  styleUrls: ['./tramit-stages.component.scss'],
  providers: [
    TramitStagesDataService,
    TramitStagesFormService,
    StagesTimeControlDataService,
    TimeContolDataService,
  ]
})

export class TramitStagesComponent implements OnInit {

  // Historial de las decisiones del usuario en los filtros de las tablas default
  history: History = new History();
  // Define la accion a realizar en el formulario
  actionForm = '';
  // Pregunta de la modal de confirmaciones
  question = '';
  // Contiene el id del grupo seleccionado
  idTramiteSelect = -1;
  // Contiene el id del grupo seleccionado
  idEtapaSelect = -1;
  // Define si el rol en accion es para editar o agregar
  rolEdit = true;
  // Define cuando mostrar la tabla principal o el formulario
  formOpen = false;
  // Define cuando mostrar la tabla Ver detalles de la etapa
  formViewOpen = false;
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    created: false,
    review: false,
    update: false,
    delete: false,
  };
  // Configuracion de la tabla
  settings = {};
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // contiene la informacion de las etapas
  source: InfoStages[];
  // Contiene la informacion de la etapa seleccionada
  tramiteStageSelect: InfoStages;
  // Contiene la lista de los detalles de la etapa
  @Input() stages: Array<EtapaBase> = [];
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];

  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngMultiSelect') ngMultiSelectSelectTpl: TemplateRef<any>;
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
  // Componente select-tramite
  @ViewChild(SelectTramiteComponent) stcRef: SelectTramiteComponent;
  constructor(
    private as: AuthenticationService,
    private toastr: ToastrService,
    private tsds: TramitStagesDataService,
    private tsfs: TramitStagesFormService,
    private tcds: TimeContolDataService,

  ) { }

  ngOnInit() {
    // determina los permisos del usuario en sesions
    this.activateAction.created = this.as.confirmPermission(
      Const.types_permissions.administracionEtapas,
      Const.types_action_permissions.created,
    );
    this.activateAction.review = this.as.confirmPermission(
      Const.types_permissions.administracionEtapas,
      Const.types_action_permissions.review,
    );
    this.activateAction.update = this.as.confirmPermission(
      Const.types_permissions.administracionEtapas,
      Const.types_action_permissions.update,
    );
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.administracionEtapas,
      Const.types_action_permissions.delete,
    );

    const configTable = new TramitStagesConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      log.debug(res.action, res.data);
      this.defineActionCondictions(res.action, res.data);
    });
  }


  /**
   * controla el historial de cambios de los selectores categoria, proceso y tramite
   *
   * @memberof TramitStagesComponent
   */
  ngAfterViewInit() {
    this.history.active = true;
    // Vigilar los cambios que se producen en los selects de categoria, proceso y tramite.
    this.stcRef.dataObserver.subscribe((change: any) => {
      if (change.target === 'category') {
        this.history.category = change.data as Categoria;
      }
      if (change.target === 'process') {
        this.history.process = change.data as Proceso;
      }
      if (change.target === 'tramite') {
        this.history.tramite = change.data as TramiteDefaultCorto;

      }
    });
  }


  /**
   * Controla las diferentes acciones de agregar, modificar o eliminar
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof TramitStagesComponent
   */
  defineActionCondictions(action: 'add' | 'update' | 'delete' = 'add', data?: any) {
     switch (action.toString()) {
      case 'add':
        if (this.activateAction.created) {
          this.formOpen = true;
          this.rolEdit = false;
          this.actionForm = 'Agregar';
          this.backupDataSelectTramiteComponent();
          this.controls = this.tsfs.getFormTramitStage(
            {
              ngSelect: this.ngSelectTpl
            },
            {
              value: this.stages
            },
            data
          );
        } else {
          this.toastr.error(
            'Usted no posee permisos para agregar detalles de las etapas en el sistema',
            'Permiso denegado'
          );
        }
        break;
      case 'update':
        if (this.activateAction.update) {
          this.formOpen = true;
          this.rolEdit = true;
          this.actionForm = 'Modificar';
          this.tramiteStageSelect = data;
          this.backupDataSelectTramiteComponent();
          this.controls = this.tsfs.getFormTramitStage(
            {
              ngSelect: this.ngSelectTpl
            },
            {
              value: this.stages
            },
            this.tramiteStageSelect
          );
        } else {
          this.toastr.error(
            'Usted no posee permisos para modificar detalles de las etapas en el sistema',
            'Permiso denegado'
          );
        }
        break;
      case 'detail':
        if (this.activateAction.review) {
          this.actionForm = 'detail';
          this.tramiteStageSelect = data;
          this.idEtapaSelect = this.tramiteStageSelect.id;
          this.formViewOpen = true;
        } else {
          this.toastr.error(
            'Usted no posee permisos para ver los detalles de las etapas en el sistema',
            'Permiso denegado'
          );
        }
        break;
      case 'delete':
        if (this.activateAction.delete) {
          this.tramiteStageSelect = data;
          this.question = '¿Realmente desea eliminar el detalle de la etapa?';
          this.confirm.open();
        } else {
          this.toastr.error(
            'Usted no posee permisos para eliminar el detalle de las etapas en el sistema',
            'Permiso denegado'
          );
        }
        break;
    }
  }

  /**
   * Carga informacion adicional de las etapas
   *
   * @memberof TramitStagesComponent
   */
  loadingStagesDetail() {
    this.idTramiteSelect = this.history.tramite.id;
    this.source = [];
    if (this.activateAction.review) {
      this.tsds.getTramitStagDetail(this.idTramiteSelect).subscribe(
        stagesDetail => {
          // Verificacion de stagesDetail, en caso de estar pasa a LocalDataSource un array vacio
          if (stagesDetail.length) {
            stagesDetail.forEach(sdetail => {
              this.source.push({
                id: sdetail.id,
                etapa: sdetail.etapa.nombre,
                etapa_id: sdetail.etapa.id,
                tiempo: sdetail.tiempo,
                porcentaje_alerta: sdetail.porcentaje_alerta,
                dias_habiles: sdetail.dias_habiles,
                delete: this.activateAction.delete,
                update: this.activateAction.update,
                review: this.activateAction.update || this.activateAction.delete || this.activateAction.review ? true : false,
              });
  
              this.sourceData = new LocalDataSource(this.source);
              
            });
          } else {
            this.sourceData = new LocalDataSource(this.source);
          }
          // stagesDetail.forEach(sdetail => {
          //   this.source.push({
          //     id: sdetail.id,
          //     etapa: sdetail.etapa.nombre,
          //     etapa_id: sdetail.etapa.id,
          //     tiempo: sdetail.tiempo,
          //     porcentaje_alerta: sdetail.porcentaje_alerta,
          //     dias_habiles: sdetail.dias_habiles,
          //     delete: this.activateAction.delete,
          //     update: this.activateAction.update,
          //     review: this.activateAction.update || this.activateAction.delete || this.activateAction.review ? true : false,
          //   });

          //   this.sourceData = new LocalDataSource(this.source);
            
          // });
        });
    } else {
      this.toastr.error('Usted no posee permisos para ver el detalle de las etapas del tramite', 'Permiso denegado');
    }
  }


  /**
   * Guarda o edita informacion adiconal de la etapa
   *
   * @param {*} data
   * @memberof TramitStagesComponent
   */
  sended(data: any) {

    if (data) {
      let stageDetail: EtapaDetalleApi;
      stageDetail = {
        tramite: this.history.tramite.id,
        etapa: data.cboEtapa,
        tiempo: data.txtTiempo,
        porcentaje_alerta: data.txtPorcentajeAlerta,
        dias_habiles: data.chHabiles,
      };
      if (this.rolEdit) {
        this.tsds.updateTramitStage(this.tramiteStageSelect.id, stageDetail).then(() => {
          this.loadingStagesDetail();
          this.closeFormTramitStages();
        }).catch(() => {
          this.closeFormTramitStages();
        });
      } else {
        this.tsds.addTramitStage(stageDetail).then(() => {
          this.loadingStagesDetail();
          this.closeFormTramitStages();
        }).catch(() => {
          this.closeFormTramitStages();
        });
      }
    }
  }


  /**
   * Controla la respuesta del modal de confirmaciones
   *
   * @param {boolean} res
   * @memberof TramitStagesComponent
   */
  actionComfirm(res: boolean) {
    if (res) {
      this.deleteStagesDetail();
    }
    this.question = '';
  }


  /**
   * Cierra el formulario o reinicia el componente a la tabla principal
   *
   * @memberof TramitStagesComponent
   */
  closeFormTramitStages() {
    this.actionForm = '';
    this.question = '';
    this.formOpen = false;
    this.tramiteStageSelect = null;
  }




  /**
   * Elimina un inforamacion adicional de una etapa
   *
   * @private
   * @memberof TramitStagesComponent
   */
  private deleteStagesDetail() {
    this.tsds.deleteTramitStage(this.tramiteStageSelect.id).then(() => {
      this.loadingStagesDetail();
      this.closeFormTramitStages();
    }).catch(() => {
      this.closeFormTramitStages();
    });
  }


  /**
   * Guardar copia de los datos de SelectTramiteComponent
   *
   * @private
   * @memberof TramitStagesComponent
   */
  private backupDataSelectTramiteComponent() {
    const backup = this.stcRef.getAll();
    for (const key in backup) {
      if (backup.hasOwnProperty(key)) {
        this.history[key] = backup[key];
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/management-automation/time-control/tramit-stages/tramit-stages.component.ts